import { render, staticRenderFns } from "./orderSales.vue?vue&type=template&id=ce73b74e&scoped=true"
import script from "./orderSales.vue?vue&type=script&lang=js"
export * from "./orderSales.vue?vue&type=script&lang=js"
import style0 from "./orderSales.vue?vue&type=style&index=0&id=ce73b74e&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce73b74e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce73b74e')) {
      api.createRecord('ce73b74e', component.options)
    } else {
      api.reload('ce73b74e', component.options)
    }
    module.hot.accept("./orderSales.vue?vue&type=template&id=ce73b74e&scoped=true", function () {
      api.rerender('ce73b74e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/orderSales.vue"
export default component.exports